import { cn } from "@/utils/utils";
import { PropsWithChildren } from "react";

interface DarkCardProps extends PropsWithChildren {
  borderClassName?: string;
  className?: string;
}

export const DarkCard = ({
  children,
  borderClassName,
  className,
}: DarkCardProps) => {
  return (
    <div
      className={cn(
        "h-fit w-fit rounded-2xl bg-glass-border p-[0.6px] shadow-dark-card",
        borderClassName,
      )}
    >
      <div
        className={cn(
          "flex h-full select-none flex-col gap-8 rounded-2xl bg-card-dark p-8 text-white",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};
